import { RestSlice } from '../../../../redux/rest.slice';
import { IppPendingRegistrationUser } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippPendingRegistrationSlice = new RestSlice<IppPendingRegistrationUser>(
	localizationService.getLocalizedString('ipp.pendingRegistrationsList.pageHeading'),
	Resource.IppPendingRegistration
);
export default ippPendingRegistrationSlice.rests.reducer;
